import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { SHARED_TYPOGRAPHY } from '../../../theme';

/**
 * TemplateList Component
 *
 * Displays a list of templates with their performance metrics
 * Used for both best and worst performing templates
 */
const TemplateList = ({
  templates,
  title,
  titleColor = 'success.main',
  maxItems = 3,
  chipColor = 'success',
}) => {
  if (!templates || templates.length === 0) {
    return (
      <Typography variant="body1" sx={SHARED_TYPOGRAPHY.bodyMediumSecondary}>
        No templates available
      </Typography>
    );
  }

  return (
    <Box>
      <Typography
        variant="h6"
        gutterBottom
        sx={{ ...SHARED_TYPOGRAPHY.bodyBold, color: titleColor }}
      >
        {title}
      </Typography>
      {templates.slice(0, maxItems).map(template => (
        <Box
          key={template.template_id}
          display="flex"
          justifyContent="space-between"
          mb={2}
        >
          <Typography variant="body1" sx={SHARED_TYPOGRAPHY.bodyBold}>
            {template.template_name}
          </Typography>
          <Chip
            label={`${template.success_rate.toFixed(1)}%`}
            color={chipColor}
            size="medium"
          />
        </Box>
      ))}
    </Box>
  );
};

export default TemplateList;
